var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_21739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3996 52.7991C40.9797 52.7991 52.7991 40.9797 52.7991 26.3996C52.7991 11.8195 40.9797 0 26.3996 0C11.8195 0 0 11.8195 0 26.3996C0 40.9797 11.8195 52.7991 26.3996 52.7991Z",
    fill: "url(#paint0_linear_1197_21739)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4405 11.2883H15.3634C13.1143 11.2883 11.291 13.1115 11.291 15.3607V37.4378C11.291 39.6871 13.1142 41.5102 15.3634 41.5102H26.2515L26.2704 30.7109H23.4644C23.0998 30.7109 22.8038 30.416 22.8026 30.0513L22.7889 26.57C22.7874 26.2036 23.0845 25.9054 23.4509 25.9054H26.2519V22.5418C26.2519 18.6383 28.6359 16.5129 32.118 16.5129H34.9756C35.3409 16.5129 35.6376 16.8092 35.6376 17.1749V20.1101C35.6376 20.4758 35.3412 20.7722 34.976 20.7722L33.2223 20.7732C31.3286 20.7732 30.9617 21.673 30.9617 22.9938V25.9059H35.1228C35.5196 25.9059 35.8272 26.2521 35.7802 26.6456L35.3676 30.1269C35.3283 30.4602 35.0457 30.7111 34.7102 30.7111H30.9805L30.9616 41.5108H37.4404C39.6894 41.5108 41.5128 39.6874 41.5128 37.4383V15.3607C41.5129 13.1117 39.6895 11.2883 37.4405 11.2883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2502 41.5102L26.2693 30.7109H26.2227V41.5102H26.2502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_21739",
    x1: 26.3996,
    y1: 0,
    x2: 26.3996,
    y2: 52.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E598F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24306D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_21739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7994,
    height: 52.7994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fd34da87405fe12d2ec340e6e5743adc.svg";
export { ForwardRef as ReactComponent };